/* eslint-disable no-unused-expressions */
/******************************************************************************
 * PageView Hook
 * version: 1.0.3, release: 07.12.2022
 * author: albert lang, albert.lang@jumptoday.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * - update source data
 * - history
 * - swipeview
 * - goBack, goHome
 * 
******************************************************************************/


import React, { useEffect, useState } from 'react';
import SwipeControl from '../utils/SwipeControl';
import './PageView.scss';


export default function PageView(props){
	const [selectedIndex, setSelectedIndex] = useState(-1);		//selected page-id


	// ------------------------------------------------------------------------ getPage
	const getPage = id => {
		id = '_' + id;
		return setup.pages.find(p => p.id === id) || null;
	}


	// ------------------------------------------------------------------------ addPage
	// add page or select if already exists
	//
	const addPage = (source, select=true) => {
		if (!source) return selectPage(-1);

		if (Array.isArray(source)){		//source array
			return source.map(s => addPage(s, false));
		}

		let page = source? getPage(source.$$typeof? source.props.id : source.id) : null;
		let data;

		if (page){	//page already exists
			return (select && setup.selectedPage !== page)? selectPage(page) : page;
		}

		if (typeof source === 'function') source = React.createElement(source);
		else if (!source.$$typeof){
			if (source.nodes){			//object has source list-node
				return source.nodes.forEach(s => addPage(s, false));
			}
			if (!source.source) return selectPage(-1);

			if (source.source.$$typeof){
				data = source;
				source = React.cloneElement(source.source);

			}else if (typeof source.source === 'function'){	//object has source sub-element
				source = React.createElement(source.source, source);
			}
		}

		if (!source || !source.$$typeof){
			console.error('wrong page source!', source);
			return null;
		}

		let index = setup.pages.length;
		let sp = source.props;
		let id = '_' + String(sp.id || index);

		page = {index, id, source, props:sp, data,
			init		: !!sp.automount || !!props.automount,
			selected	: false,
			active		: true,
			noscroll	: !!sp.noscroll,
			_cid		: 'page-item'
		};

		// console.log('---add page', index, id, page);
		setup.pages.push(page);
		
		if (select) selectPage(index);	//select default page 0

		return page;
	}


	// ------------------------------------------------------------------------ selectPage
	// set i = -1 or null to clear the current selected page
	const selectPage = i => {
		let page = i && i._cid === 'page-item'? i : typeof i === 'string'? getPage(i) : setup.pages[i];
		if (page === setup.selectedPage) return page;
		if (!page && i !== -1 && i !== null) return null		//skip if selected page not exists

		// console.log('---pageView select page', i, page);
		if (setup.selectedPage) setup.selectedPage.selected = false;	//reset lastPage
		setup.lastIndex = setup.selectedIndex;

		let index = -1
		if (!page){
			setup.selectedPage = null;
			setup.selectedIndex = -1;
			setup.history = []

		}else{
			index = setup.pages.indexOf(page);
			setup.selectedIndex = index;
	
			page.selected = true;
			setup.selectedPage = page;
	
			if (!page.init){
				page.init = true;
				// console.log('---pageView init page', index)
			}

			// ---set history
			let p = setup.history.indexOf(index)
			if (p > -1) setup.history = setup.history.slice(0, p + 1)	//index already in the history
			else setup.history.push(index)
			// console.info('history:', index, setup.history)
		}

		setSelectedIndex(index);

		if (page) setup.onSelect?.(index, page);
		return page;
	}


	const selectNext = () => {
		if (!setup.numPages) return selectPage(-1);
		if (!setup.loop && setup.selectedIndex === setup.numPages-1) return
		if (setup.numPages === 1 && setup.selectedPage && setup.selectedPage.active) return setup.selectedPage;		//keep current

		if (setup.selectedIndex === -1) return selectFirst();

		setup.slideTo = 'next';
		let i = setup.pages.findIndex(p => p.index > setup.selectedIndex && p.active !== false);	//find next
		if (i === -1) i = setup.pages.findIndex(p => p.active !== false);		//find from beginning
		return selectPage(i);
	}


	const selectPrev = e => {
		if (!setup.numPages) return selectPage(-1);
		if (!setup.loop && setup.selectedIndex === 0) return
		if (setup.numPages === 1 && setup.selectedPage && setup.selectedPage.active) return;		//keep current

		if (setup.selectedIndex === -1) return selectLast();

		setup.slideTo = 'prev';
		let i = setup.selectedIndex;
		while(i--) if (setup.pages[i].active !== false) break;
		if (i === -1){
			i = setup.pages.length;
			while(i--) if (setup.pages[i].active !== false) break;
		}
		return selectPage(i);
	}


	const selectFirst = e => {
		if (!setup.numPages) return selectPage(-1);
		if (setup.numPages === 1 && setup.selectedPage && setup.selectedPage.active) return;		//keep current

		setup.slideTo = 'prev';
		let i = setup.pages.findIndex(p => p.active !== false);
		selectPage(i);
	}


	const selectLast = e => {
		if (!setup.numPages) return selectPage(-1);
		if (setup.numPages === 1 && setup.selectedPage && setup.selectedPage.active) return;		//keep current

		setup.slideTo = 'next';
		let i = setup.pages.length;
		while(i--) if (setup.pages[i].active !== false) break;
		selectPage(i);
	}


	const goBack = e => {
		if (setup.history.length > 1) selectPage(setup.history[setup.history.length-2])
	}


	const goForward = e => {
		///
	}


	//reset animate, autoPlay, and go to first frame
	const reset = e => {
		// console.log('---reset page list!');
		// stop();
		setup.animate = false;
		selectFirst();
	}
	

	const setFilter = fnc => {
		setup.pages.forEach(p => p.active = fnc(p));
		// if (!setup.selectedPage || setup.selectedPage?.active === false){
		// 	selectFirst();
		// }
		if (setup.selectedPage?.active === false){
			selectPage(-1)		//if current selected page is not active than clear selection
		}
	}


const clear = e => {
	// console.log('---pageView clear!')
	// stop();
	setup.pages = [];		//filtered pages
	setup.numPages = 0;
	setup.isLoaded = false;
	setup.lastIndex = -1;
	setup.selectedPage = null;
	setup.selectedIndex = -1;
	setup.history = [];
}

	const [setup] = useState(() => {
		let fn = typeof props.setup === 'function'? props.setup : null;
		let s = (!fn && props.setup) || {};

		s.addPage = addPage;
		s.getPage = getPage;
		s.selectPage = selectPage;
		s.selectNext = selectNext;
		s.selectPrev = selectPrev;
		s.selectFirst = selectFirst;
		s.selectLast = selectLast;
		s.setFilter = setFilter;
		s.goBack = goBack;

		s.isLoaded = false;
		s.isPlaying = false;
		s.loop = props.loop ?? s.loop ?? false;	//loop page navigation
		s.animate = props.animate;
		s.autoPlay = props.autoPlay || s.autoPlay;

		// s.start = start;
		// s.stop = stop;
		s.reset = reset;	//reset animate, autoPlay, and go to first frame
		s.clear = clear;

		s.onSelect = props.onSelect || s.onSelect;
		s.onLoadComplete = props.onLoadComplete || s.onLoadComplete;

		s.pages = [];		//filtered pages to show
		s.numPages = 0;
		s.lastIndex = -1;
		s.selectedPage = null;
		s.selectedIndex = -1;
		s.history = [];

		if (fn) fn(s);		//return setup if function
		return s
	})


	useEffect(() => {
		// console.log('---init page-view');

		if (setup.view && (props.swipe || props.onSwipe)){
			// new PointerControl(setup.view)

			let sc = new SwipeControl(setup.view, {
				onSwipe : e => {
					if (props.swipe){
						// console.log('---swipe', e);
						// stop();
						if (e === 'left') selectNext();
						else if (e === 'right') selectPrev();
						// if (setup.autoPlay) start();	//restart animation
					}
					if (props.onSwipe) props.onSwipe(e);
				}
			})
		}

// clear();

// if (props.children){
// 	let childs = Array.isArray(props.children)? props.children : [props.children];
// 	childs.forEach(c => addPage(c, false))
// }

// if (props.source) props.source.forEach(s => addPage(s, false));

// setup.numPages = setup.pages.length;

// selectPage(props.selectedIndex || 0);	//select default page 0

// setup.isLoaded = true;
// setup.onLoadComplete?.();

		return () => {}
		// stop();
	}, [])


	useEffect(() => {
		// console.log('---pageView update')
		if (props.children === undefined && props.source === undefined) return;

		clear();

		if (props.children){
			let childs = Array.isArray(props.children)? props.children : [props.children];
			childs.forEach(c => addPage(c, false))
		}

		if (props.source) props.source.forEach(s => addPage(s, false));

		setup.numPages = setup.pages.length;

		selectPage(props.selectedIndex || 0);	//select default page 0

		setup.isLoaded = true;
		setup.onLoadComplete?.();

		// if (setup.autoPlay) start();

	}, [props.children, props.source])


	useEffect(() => {
		if (props.selectedIndex === undefined || props.selectedIndex === selectedIndex) return;
		selectPage(props.selectedIndex);

	}, [props.selectedIndex])


	useEffect(() => {
		if (props.selectedId === undefined ||
			(setup.selectedPage && props.selectedId === setup.selectedPage.id)) return;
		selectPage(props.selectedId);

	}, [props.selectedId])


	return (
		<div
			className='ui2-pageview'
			id={props.id}
			ref={e => {if (e) setup.view = e}}
			onClick={props.onClick}
			// onClick={e => {
			// 	if (props.autoPlay){
			// 		if (setup.isPlaying) stop();
			// 		else start();
			// 	}
			// }}
			style={props.style}
			>
			{setup.pages.map((p, i) => 
				// (!p.selected && (p.props.autounmount || props.autounmount || !p.init))?
				// null
				// :
				(props.automount || p.selected ||
					(p.init && (p.props.autounmount === false || props.autounmount === false))) &&
				<Page
					key={i}
					className={props.pageClass || 'ui2-page'
						+ (p.selected? ' selected' + (setup.slideTo? ' ' + setup.slideTo : '') : '')
						+ (i === setup.lastIndex? setup.slideTo === 'next'? ' prev' : ' next' : '')
						// + (p.selected? ' selected' : '')
						// + (p.selected? i > last? ' next' : i < last? ' prev' : '' : '')
						// + (i === last? i < idx? ' prev' : i > idx? ' next' : '' : '')
						+ ((p.noscroll || props.noscroll)? ' noscroll' : '')
						+ (setup.animate && setup.lastIndex !== -1? ' animate' : '')}
					{...p}
				/>
			)}
		</div>
	)
}


// const Page = memo(props => {
// 	return <div id={props.id} className={props.className}>
// 		{React.cloneElement(props.source, {selected:props.selected, props})}
// 	</div>
// })

const Page = (props) => {
	return <div id={props.id} className={props.className}>
		{React.cloneElement(props.source, {selected:props.selected, props})}
	</div>
}
